const Form010EN = {
    stepName: {
        ImportantNotes: "Notes",
        FormExpired: "Notes",
        Application: "Application Information",
        AcademicDetails: "Academic Details & Responsibilities in School",
        LanguageProficiency: "Language Proficiency, Interests and Talents",
        TravelingExperience: "Traveling Experience",
        FurtherInformation: "Further Information",
        Declaration: "Declaration",
        Consent: "Parental / Guardian’s Consent",
        FormA: "Section A",
        FormB: "Recommendations",
        SectionB: "Section B & C",
        SectionD: "Section D",
        SectionE: "Section E & F",
        SectionG: "Section G",
        SectionH: "Section H & I",
        SectionJ: "Section J and the Note",
        Confirmation: "Confirmation",
    },
    title: {
        note: "Note",
        collectionPersonal: "Collection of Personal Data",
        languageProficiency: "(D) Language Proficiency",
        employment: "Employment",
        personalParticulars: "(A) Personal Particulars",
        hkPersonTitle: "Person to be contacted in Hong Kong",
        exchangeProgramme: "Exchange Programme",
        exchangeProgrammeTitle:
            "Have you ever led any other student exchange programme(s) in the past?",
        exchangeProgrammeTableTitle: "If Yes, please provide information.",
        InterestsAndHobbies: "Interests and Hobbies",
        InterestsAndHobbiesTableTitle:
            "State your interests and hobbies below and attach supporting documents, if any:",
        part2: "Part II",
        part2title:
            "Recommendations - to be completed by the Principal of the nominating school",
        undertakeTitle: `(b) I understand the selection of student-delegates is independent of the teacher-chaperons. If my student nominee is selected, 
        notwithstanding of whether the teacher I also nominated for the JENESYS Programme (if any) is selected or not,
        I will undertake to release the student from {{undertakeDate}} inclusive to join the exchange visit. 
        I will remind him / her to attend all the activities and behave properly during the visit.`,
        academicDetails: "(B) Academic Details",
        responsibilitiesInSchool: "(C) Responsibilities in School",
        interestsTalents: "(E) Interests and Talents",
        TravelingExperience: "(F) Traveling Experience",
        FurtherInformation: "(H) Further Information",
        questions: "(G) Please answer the following questions",
        Declaration: "(I) Declaration",
        Consent: "(J) Parental / Guardian’s Consent",
        consentTitle: `I agree my son / daughter’s participation in the JENESYS Programme and I will urge him / her to fulfill all the responsibilities and obligations as listed at (I) if he/she is selected.`,
    },
    label: {
        japanese: "Japanese",
        english: "English",
        putonghua: "Putonghua",
        proficiencyOptions: {
            fluent: "Fluent",
            canExpress: "A Little",
            cannotSpeak: "Do Not Know",
        },
        remarks: "Remarks",
        canSpeakJapanese: "(a) Language Standard",
        everLearntJapanese: "(b) Have you ever learnt Japanese?",
        outstandingPerformance:
            "(c)  Have you had outstanding performance in Putonghua and/or English? (e.g. attaining Level 2 Grade B or above in Putonghua Shuiping Ceshi, Band 6 or above in IELTS)",
        outstandingPerformance1:
            "in Putonghua Shuiping Ceshi, Band 6 or above in IELTS)",
        everLearntJapaneseOptions: {
            yes: "Yes",
            no: "No",
        },
        learntJapaneseNote:
            "If Yes, please provide information in the following by filling and attach a copy of the supporting document(s):",
        courseName: "Name of Course",
        attainedLevel: "Level Attained",
        startDate: "Start Date",
        completeDate: "Completion Date",
        schoolName: "Name of School",
        schoolAddress: "School Address",
        schoolTel: "Tel No.",
        schoolFax: "Fax No.",
        positionHeld: "Position Held",
        positionHeldOptions: {
            assistantPrincipal: "Assistant Principal",
            seniorTeacher: "Senior Teacher",
            teacher: "Teacher",
        },
        presentSchoolDate: "Date to Present School",
        presentPostDate: "Date to Present Post",
        taughtTitle:
            "Subject(s) Taught in Senior Classes in the Current School Year",
        taughtSubject: "Subject(s) Taught",
        taughtLevel: "Level Taught",
        taughtRemarks: "Remarks",
        headTitle:
            "Non-teaching Duties (class teacher / club adviser / activity coordinator, etc.)",
        headPosition: "Position Held",
        natureOfDuty: "Nature of Duty",
        period: "Period",
        headRemarks: "Remarks",
        experienceTitle:
            "Other Working Experience (including non-teaching experience and overseas working experience)",
        instituteName: "Name of Institute / Organization",
        nameRemark: "Name (as appeared in the HKSAR Passport)",
        englishName: "English",
        chineseName: "Chinese",
        chineseCodeName: "Name (Chinese Character Code)",
        birthDate: "Date of Birth",
        birthPlace: "Place of Birth",
        sex: "Sex",
        hkIDNo: "HKID No.",
        homeAddress: "Home Address",
        photoAttachment: "Affix a photo here",
        homeTel: "Contact Tel. No.",
        mobilePhone: "Mobile Phone No.",
        eMailAddress: "E-mail Address",
        faxNo: "Fax No.",
        hkSARPassportNumber: "Have you held a valid HKSAR Passport?",
        expiryDate: "Date of Expiry",
        issueDate: "Date of Issue",
        sexOption: {
            Male: "Male",
            Female: "Female",
        },
        hkPersonEnName: "Name (English)",
        hkPersonCnName: "Name (Chinese)",
        hkPersonRelationship: "Relationship with the Nominee",
        hkPersonAddress: "Address",
        hkPersonHomeTel: "Contact Tel. No.",
        hkPersonMobliePhone: "Mobile Phone No.",
        hkPersonEmail: "E-mail Address",
        hkPersonFax: "Fax No.",
        exchangeProgrammePeriod: "Period",
        exchangeProgrammeHostingOrganization: "Hosting Organisation",
        exchangeProgrammePlace: "Place / Country visited",
        exchangeProgrammePurpose: "Purpose of the visit",
        exchangeProgrammeHostingRole: "Your role in the visit",
        interestsOrHobbies: "Interests / Hobbies",
        achievements: "Achievements (relevant records, if any)",
        gotFirstAidTraining: "Have you got first aid training?",
        gotFirstAidTrainingTitle:
            "If Yes, please state the expiry date of the first aid certificate and attach a copy of it.",
        firstAidCertificateExpiryDate:
            "Date of expiry of the first aid certificate (dd / mm / yyyy)",
        trainUpStudentDelegatesArea:
            "State in which area(s), e.g. simple Japanese, speech, choir, etc. that you can train up the student delegates",
        supportingApplicationInformation:
            "State any further information you consider useful in supporting your application, e.g. worked as Japanese interpreter, etc",
        attendActivities:
            "(a) If you are selected, are you able to attend the activities which are held in the morning / afternoon at week-ends and late afternoon / evening on week days?",
        attendActivitiesOptions: {
            yes: "Yes",
            no: "No",
            notSure: "Not sure",
        },
        nomineeName: "Name of Nominee",
        nominationReasons:
            "(a) My nomination is based on the following reasons",
        principalName: "Name of Principal",
        contactTel: "Contact Tel. No.",
        academicDetailsSchoolName: "Name of School",
        academicDetailsSchoolAddress: "School Address",
        academicDetailsLevel: "Level",
        electiveSubject: "Elective Subjects:",
        examinationReports:
            "Please attach copies of your last two examination reports in Secondary Four.",
        responsibilitiesPeriod: "Period",
        studentUnion: "Student Union / Society / Club",
        post: "Post",
        experiencesBenefit: "How do you benefit from these experiences?",
        examinationName: "Name of Examination / Competition",
        levelAttained: "Level Attained",
        completionDate: "Completion Date / Award Date",
        interestsOrTalents: "Interests / Talents",
        interestsOrTalentsAchievements:
            "Achievements (relevant records, if any)",
        interestsOrTalentsAttachment:
            "State your interests and talents and attach a copy of the supporting document(s), if any:",
        countryVisited: "Country Visited",
        travelingPeriodFrom: "Period From",
        travelingPeriodTo: "Period To",
        travelingTimes: "Times (up to {{travelingTimes}})",
        travelingPurpose:
            "Purpose (e.g. Sight-Seeing, Exchange Visit, Voluntary Service)",
        interestedProgramme:
            "(a) Why are you interested in the JENESYS Programme?",
        expectProgramme: "(b) What do you expect from the JENESYS Programme?",
        shareExperience:
            "(c) How will you share your experience with your peers after the visit?",
        appliedActivities:
            "(b) Have you ever applied for / been admitted to any other exchange programmes and / or similar activities to be conducted from {{appliedTime}}?",
        provideInformation: "(i) If Yes, please provide information below.",
        appliedActivitiesPeriod: "Period",
        appliedActivitiesProgramme: "Programme(s)",
        appliedActivitiesOrganization: "Hosting Organisation",
        appliedActivitiesRemarks: "Remarks",
        appliedActivitiesRemarksOptions: {
            underApplication: "under application",
            admitted: "admitted",
        },
        giveUpProgramme:
            "(ii) If you are selected to join the JENESYS Programme, are you willing / able to give up the exchange programme(s) to be held in the same period?",
        giveUpProgrammeOptions: {
            yes: "Yes",
            no: "No",
        },
        parentName: "Name of Parent / Guardian",
        nomineeRelationship: "Relationship with the Nominee",
        parentSign: "Signature of Parent / Guardian",
        pleaseContact:
            "(c) For any enquiry about this nomination, please contact",
        teacherName: "name of responsible teacher",
        teacherSexOptions: {
            Mr: "Mr",
            Ms: "Ms",
        },
        nomineeSign: "Signature of Nominee",
        approverEmailAddress: "E-mail Address",
        hasPassNoTips: "If YES, please provide the expiry date of HKSAR Passport:",
        passNoExpireDate: "Expiry Date of HKSAR Passport (dd / mm / yyyy)"
    },
    options: {
        hasPassNoOp: {
            yes: "Yes",
            no: "No",
        }
    },
    errorMsg: {
        englishName: "English Name",
        chineseName: "Chinese Name",
        appliedActivitiesPeriod:
            "Please select date between November and December 2025",
    },
    note: {
        note1: "(a) School should submit the nomination form(s) and relevant documents <b>{{deadline}}.</b> School may submit the completed nomination form and upload the support documents via the Common Log-on system (https://clo.edb.gov.hk/).",
        note2: "(b) Information given in this form will be used for processing application for the JENESYS Programme.",
        note3: `(c) One recent full-face photograph of the nominee uploaded to this form is required.`,
        note4: "(d) Failure to provide information / documents as required may result in the application being declined.",
        note5: "(1) The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s):",
        note6: "(a) processing application for the JENESYS Programme; and",
        note7: "(b) conducting related research and compiling statistics to facilitate planning of related education services.",
        note8: "(2) The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
        note9: "(3) The personal data collected in this form may be disclosed to other government departments / bureaux or the receiving parties for the purposes mentioned above.",
        note10: "(4) You have a right to request access to and correction of your personal data as provided for in Section 18 and 22 and Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee.",
        note11: "(5) Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be addressed to the Extended Support Programmes Section, the Education Bureau, Room 1141, 11/F, Wu Chung House, 213 Queen’s Road East, Wanchai, Hong Kong (Tel. No.: 2892 6663).",
        note12: "(a) I declare that the information provided above is true and correct.",
        note13: "(b) If selected, I undertake to:",
        note14: "behave properly, be disciplined as a student-delegate and perform all responsibilities and obligations as required;",
        note15: "attend all pre-tour meetings, training sessions, briefing sessions, rehearsals, etc., and understand that failure to attend any of these activities may result in disqualification as a member of the delegation;",
        note16: "prepare relevant materials on Hong Kong for presentation to the receiving parties;",
        note17: "participate in talent shows during the exchange visit;",
        note18: "complete an individual evaluation form after the exchange visit;",
        note19: "complete a group report on the outcome of the exchange visit within one and a half months after the visit; and",
        note20: "attend relevant functions as and when invited or requested by EDB or the sponsor.",
        note21: "Completed nomination form together with the following documents should be submitted:",
        note22: "(a) A recent full-face photograph;",
        note23: "(b) Copies of the last two examination reports in Secondary Four;",
        note24: "(c) A copy of the supporting document(s) of proficiency in / studying of Japanese, if any; and",
        note25: "(d) A copy of the supporting document(s) of outstanding performance in Putonghua and/or English, if any.",
    },
    button: {
        submit: "Submit",
        sign: "Sign",
    },
};

export default Form010EN;

